import { useCallback } from 'react';
import { RequestAnalytics } from '../../components/stats';
import type { AnalyticsJob } from '../../components/stats';
import type { DateRange } from '../../types';
import { listHistoryJobs } from '../api';
import type { Job } from '../types';

/**
 * Interior Overview page — mirrors lightning's overview analytics using
 * the interior service's history API.
 */
export function InteriorOverviewPage() {
  const fetchAnalyticsJobs = useCallback(
    async (range: DateRange): Promise<AnalyticsJob[]> => {
      const allJobs: Job[] = [];
      const pageSize = 500;
      let page = 1;
      let totalPages = 1;
      do {
        const resp = await listHistoryJobs(range, null, page, pageSize);
        allJobs.push(...resp.jobs);
        totalPages = resp.total_pages;
        if (resp.jobs.length === 0) break;
        page += 1;
      } while (page <= totalPages);
      return allJobs.map((j) => ({
        id: j.job_id,
        scan_id: j.scan_id,
        created_at: j.created_at,
        status: j.status,
        duration_seconds: j.duration_seconds,
        error: j.error,
      }));
    },
    [],
  );

  return (
    <div className="space-y-6">
      {/* Request analytics */}
      <RequestAnalytics fetchJobs={fetchAnalyticsJobs} statsHref="/interior/stats" />
    </div>
  );
}
